import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

interface EndingProps {
  userToken: string;
  finalMessage: GameFinalMessageT;
}

export default function Ending({finalMessage}: EndingProps) {
  const {t, i18n} = useTranslation();
  const langUser = i18n.language as LangUserT;

  return (
    <EndingContainer>
      <EndingInner>
        <EndingWrapper>
          <h1>{t('ending.title')}</h1>
          <MessageWrapper>
            {finalMessage[langUser] && (
              <div
                dangerouslySetInnerHTML={{__html: finalMessage[langUser]}}
              ></div>
            )}
          </MessageWrapper>
        </EndingWrapper>
      </EndingInner>
    </EndingContainer>
  );
}

const EndingContainer = styled.div`
  width: 100%;
  padding: 1.5rem;

  @media ${(props) => props.theme.breakpoints.phone} {
    padding: 1rem;
  }
`;

const EndingInner = styled.div`
  width: 100%;
  clip-path: polygon(0 0, 100% 5%, 98% 90%, 10% 100%);
  background-color: ${(props) => props.theme.colors.orange100};
  padding: 180px 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EndingWrapper = styled.div`
  width: 100%;
  max-width: 710px;
  text-align: center;

  h1 {
    color: ${(props) => props.theme.colors.violet500};
    font-size: 4rem;
    margin-bottom: 1.5rem;

    @media ${(props) => props.theme.breakpoints.tablet} {
      font-size: 3rem;
    }

    @media ${(props) => props.theme.breakpoints.phone} {
      font-size: 2rem;
    }
  }

  button {
    margin-top: 3rem;
  }
`;

const MessageWrapper = styled.div`
  font-size: 1.3rem;
  line-height: 1.5;
`;
